import { say } from "../localization/say.ts";

export function why(cause: unknown, what: "add" | "signIn"): string {
  const named = cause instanceof DOMException ? cause.name : "";
  switch (named) {
    case "NotAllowedError":
      return what === "add" ? say("why.notFinished") : say("why.notFinishedSignIn");
    case "InvalidStateError":
      return say("why.alreadyUsed");
    case "AbortError":
      return say("why.stopped");
    case "NotSupportedError":
      return say("why.cannotDoThat");
    case "SecurityError":
      return say("why.wrongPlace");
    case "ConstraintError":
      return say("why.needsAScreenLock");
    case "UnknownError":
      return say("why.deviceRefused");
    default:
      break;
  }

  return what === "add" ? say("why.noPasskeyMade") : say("why.noSignIn");
}
